import service from '@/plugins/service'

const base = '/customer'

export const getCustomerList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const getCustomerListByCompany = company => {
  return service({
    url: `${base}/search`,
    method: 'GET',
    params: {
      company
    }
  })
}

export const addCustomer = data => {
  return service({
    url: `${base}?version=2.1`,
    method: 'POST',
    data
  })
}

export const getCustomerById = id => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      id
    }
  })
}

export const updateCustomer = data => {
  return service({
    url: `${base}?version=2.1`,
    method: 'PUT',
    data
  })
}

export const searchCustomerList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const deleteCustomer = id => service({
  url: `${base}`,
  method: 'DELETE',
  params: {
    id
  }
})